import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "@/../css/slick.css";
import "@/../css/slick-theme.css";

export function LogoBoard({
  children,
  className = "",
  containerClass = "",
  title = "",
}) {
  // const containerRef = useRef(null);
  // const firstLoad = useRef(true);
  // const [direction, setDirection] = useState("right");
  // let interval = 0;

  const logos = [
    "images/logos/1.png",
    "images/logos/2.png",
    "images/logos/3.png",
    "images/logos/4.png",
    "images/logos/6.png",
    "images/logos/7.png",
    "images/logos/8.gif",
    "images/logos/9.jpg",
    "images/logos/10.png",
    "images/logos/11.png",
    "images/logos/12.png",
    "images/logos/13.png",
  ];

  logos.sort(() => Math.random() - 0.5);

  //
  // function scrollLogos() {
  //   const container = containerRef.current;
  //
  //   if (!container) return;
  //   const containerWidth = container.offsetWidth;
  //   const containerScrollWidth = container.scrollWidth;
  //   const scrollLeft = container.scrollLeft;
  //   const dir = container.getAttribute("data-direction");
  //   const scrollAmount =
  //     {
  //       right: 1,
  //       left: -1,
  //       stop: 0,
  //     }[dir] || 0;
  //
  //   if (dir === "right") {
  //     if (containerWidth + scrollLeft >= containerScrollWidth) {
  //       setDirection("stop");
  //       setTimeout(() => {
  //         setDirection("left");
  //       }, 2000);
  //     }
  //   } else if (dir === "left") {
  //     if (scrollLeft <= 0) {
  //       setDirection("stop");
  //       setTimeout(() => {
  //         setDirection("right");
  //       }, 2000);
  //     }
  //   }
  //   container.scrollTo({
  //     top: 0,
  //     left: scrollLeft + scrollAmount,
  //     behavior: "smooth",
  //   });
  // }
  //
  // useEffect(() => {
  //   // only run on desktop
  //   if (window.innerWidth < 768) return;
  //   clearInterval(interval);
  //   interval = setInterval(() => {
  //     scrollLogos();
  //   }, 1000 / 60); // 60fps
  //
  //   // only run on first load
  //   if (!firstLoad.current) return;
  //   firstLoad.current = false;
  //
  //   // on resize remove interval and reset direction
  //   window.addEventListener("resize", () => {
  //     if (window.innerWidth < 768) {
  //       clearInterval(interval);
  //       setDirection("right");
  //     } else {
  //       clearInterval(interval);
  //       interval = setInterval(() => {
  //         scrollLogos();
  //       }, 1000 / 60); // 60fps
  //     }
  //   });
  // }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    centerMode: true,
    draggable: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  };

  return (
    <div className={`${className}`}>
      {title && (
        <div className="flex justify-center">
          <h2 className="text-2xl font-bold">{title}</h2>
        </div>
      )}
      <div className={`${containerClass}`}>
        <Slider {...settings}>
          {logos.map((logo, index) => (
            <img src={logo} alt={`logo-${index}`} key={index} />
          ))}
        </Slider>
      </div>
      {children}
    </div>
  );
}
